import * as React from 'react';
import { l } from '../../Other/Translation';
import { PaymentMeanInterface, PaymentMeans } from '../../Interfaces/Settings/PaymentMeanInterface';
import { Input } from '../common/Input/Input';

interface PaymentMethodsProps {
  paymentMeans: PaymentMeanInterface[];
  savePaymentMeans: (paymentMeans) => void;
}

const getDefaultIBANPM = (): PaymentMeanInterface => ({
  type: PaymentMeans.IBAN,
  fields: {iban: '', swift: '', bank: ''}
});

const keys = {
  iban: 'iban',
  swift: 'swift',
  bank: 'bank'
};

export const PaymentMethods: React.FunctionComponent<PaymentMethodsProps> = ({paymentMeans, savePaymentMeans}) => {
  const pmLabel = 'paymentMethods';
  const draftIban = paymentMeans.find(p => p.type === PaymentMeans.IBAN);
  const pm = draftIban || getDefaultIBANPM();
  const saveIBAN = (ibanFields) => {
    const ibanPM = {type: PaymentMeans.IBAN, fields: ibanFields};
    const hasIB = Boolean(draftIban);
    if (hasIB) {
      paymentMeans = paymentMeans.map((p) =>
        p.type === PaymentMeans.IBAN ? ibanPM : p);
    } else {
      paymentMeans.push(ibanPM);
    }
    return savePaymentMeans(paymentMeans);
  };
  return (
    <div className={'paymentDetails'}>
      <Input
        automation={`${pmLabel}-iban`}
        value={pm.fields.iban}
        align={'left'}
        label={l(keys.iban)}
        onChange={(iban) => {
          saveIBAN({...pm.fields, iban});
        }}
      />
      <Input
        automation={`${pmLabel}-swift`}
        value={pm.fields.swift}
        align={'left'}
        label={l(keys.swift)}
        onChange={(swift) => {
          saveIBAN({...pm.fields, swift});
        }}
      />
      <Input
        automation={`${pmLabel}-bank`}
        value={pm.fields.bank}
        align={'left'}
        label={l(keys.bank)}
        onChange={(bank) => {
          saveIBAN({...pm.fields, bank});
        }}
      />
    </div>);
};
